import { create } from "zustand";
import { devtools } from "zustand/middleware";

const DEBUG = import.meta.env.VITE_DEBUG === "true";

export const createStore = (name, base) => {
  return create(DEBUG ? devtools(base, { name }) : base);
};
